<template>
  <div class="col-sm-12">
    <div class="card custom-card">

      <!-- added by isindu | 2025/ 12/ 02 -->
      <div v-if="loading" class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>


      <div v-else> <!-- added by isindu | 2025/ 12/ 02 -->
        <!-- Staff Type Selection -->
        <div class="form-group">
          <label class="block mb-3 font-semibold">Staff Type :</label>
          <div class="staff-type-container">
            <div v-for="staff in StaffTypeList" :key="staff.id" class="staff-type-box disabled-box"
              :class="{ 'selected': selectedStaffType == staff.id }">
              <div class="staff-icon">
                <i :class="['fas', staff.icon || 'fa-user']"></i>
              </div>
              <div class="staff-label">{{ staff.staff_type || staff.staf_type }}</div>
              <div class="selected-indicator" v-if="selectedStaffType == staff.id">
                <i class="fas fa-check"></i>
              </div>
            </div>
          </div>
        </div>

      <!-- Dynamic Form Fields -->
      <div v-if="selectedStaffType" class="fields-container">
        
        <!-- Name (Driver/Helper only) -->
        <div class="field-item" v-if="isDriverOrHelper">
          <label for="name" class="block mb-2 font-semibold">Name :</label>
          <input type="text" id="name" v-model="name" placeholder="Enter name" class="name-input compact" :disabled="isSaving" />
        </div>

        <!-- First Name (Back Office, Sales Exec) -->
        <div class="field-item" v-if="isBackOffice || isSalesExecutive">
          <label for="first_name" class="block mb-2 font-semibold">First Name :</label>
          <input type="text" id="first_name" v-model="firstName" placeholder="Enter first name" class="name-input compact" :disabled="isSaving" />
        </div>

        <!-- Last Name (Back Office, Sales Exec) -->
        <div class="field-item" v-if="isBackOffice || isSalesExecutive">
          <label for="last_name" class="block mb-2 font-semibold">Last Name :</label>
          <input type="text" id="last_name" v-model="lastName" placeholder="Enter last name" class="name-input compact" :disabled="isSaving" />
        </div>

        <!-- Vehicle Number (Distributor Sales Rep) -->
        <div class="field-item" v-if="isDistributorSalesRep">
          <label for="vehicle_number" class="block mb-2 font-semibold">Vehicle Number :</label>
          <select id="vehicle_number" v-model="vehicleNumber" class="name-input compact" :disabled="isSaving">
            <option value="" disabled>Select Vehicle Number</option>
            <option v-for="vehicle in VehicleList" :key="vehicle.id" :value="vehicle.vehicle_no">
              {{ vehicle.vehicle_no }}
            </option>
          </select>
        </div>

        <!-- Mobile (Username) (Back Office, Sales Exec, Distributor Sales Rep) -->
        <div class="field-item" v-if="isBackOffice || isSalesExecutive || isDistributorSalesRep">
          <label for="mobile" class="block mb-2 font-semibold">Mobile (Username) :</label>
          <input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="10" id="mobile" v-model="mobile" placeholder="Enter mobile number" class="name-input compact" :disabled="isSaving" @input="mobile = mobile.replace(/[^0-9]/g, '')" />
        </div>

        <!-- Role (Back Office) -->
        <div class="field-item" v-if="isBackOffice">
          <label for="role" class="block mb-2 font-semibold">Role :</label>
          <select id="role" v-model="selectedRole" class="name-input compact" :disabled="isSaving">
            <option :value="null" disabled>Select Role</option>
            <option v-for="r in UserRoleList" :key="r.id" :value="r.id">
              {{ r.name }}
            </option>
          </select>
        </div>


        <!-- Birthday (All Roles) -->
        <div class="field-item" v-if="isBackOffice || isSalesExecutive || isDistributorSalesRep || isDriverOrHelper">
          <label for="birthday" class="block mb-2 font-semibold">Birthday :</label>
          <input type="date" id="birthday" v-model="birthday" class="name-input compact" :disabled="isSaving" />
        </div>
        
        <!-- Active Toggle (Moved inside grid or kept below) -->
        <div class="field-item toggle-container p-0 m-0" style="flex-direction: row; justify-content: flex-start; gap: 15px;">
          <label for="isActive" class="form-label font-semibold m-0">Is Active :</label>
          <div class="toggle-wrapper">
            <label class="toggle-switch" :class="{ 'active': isActive, 'inactive': !isActive }">
              <input type="checkbox" id="isActive" v-model="isActive" :disabled="isSaving" hidden />
              <span class="toggle-slider"></span>
            </label>
          </div>
        </div>

      </div>



      <!-- Action Buttons -->
      <div class="d-flex justify-content-end action-buttons">
        <button type="button" class="btn btn-danger" @click="Cancel" :disabled="isSaving">
          Cancel
        </button>
        <button type="button" class="btn btn-success save-button" @click="updateStaff"
          :disabled="isSaving || !isFormValid">
          <span v-if="!isSaving">Update</span>
          <div v-else class="loading-indicator">
            <span class="spinner"></span>
            <span>Updating...</span>
          </div>
        </button>
      </div>

      </div> <!-- Ends v-else -->
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { viewStaffDetailsById, fetchStaffType, updateStaffDetails, updateUser, getDistributorVehicles, fetchDistributorUserRoleListForUserForm } from "@/services/dataService";
import { useToast } from "vue-toastification";

export default {
  data() {
    return {
      token: localStorage.getItem('token_set') || '',
      profileId: localStorage.getItem('profile_id'),
      reportingProfileId: localStorage.getItem('reportingL1ProfileId'),
      userCategory: localStorage.getItem('user_label'),
      router: useRouter(),
      staffId: this.$route.params.id || 1,
      StaffTypeList: [],
      selectedStaffType: "",
      name: "",
      firstName: "",
      lastName: "",
      mobile: "",
      role: "",
      birthday: "",
      vehicleNumber: "",
      selectedRole: null,
      UserRoleList: [],
      VehicleList: [],
      isActive: true,
      isSaving: false,
      loading: false, // added by isindu | 2025/ 12/ 02
    }
  },

  computed: {
    selectedStaffTypeName() {
      const staff = this.StaffTypeList.find(s => s.id === this.selectedStaffType);
      return staff ? (staff.staff_type || staff.staf_type || '').toLowerCase() : '';
    },
    isBackOffice() {
      return this.selectedStaffTypeName.includes('back office');
    },
    isSalesExecutive() {
      return this.selectedStaffTypeName.includes('sales executive');
    },
    isDistributorSalesRep() {
      return this.selectedStaffTypeName.includes('sales rep');
    },
    isDriverOrHelper() {
      return this.selectedStaffTypeName.includes('driver') || this.selectedStaffTypeName.includes('helper');
    },
    isFormValid() {
      if (!this.selectedStaffType) return false;
      
      const fName = String(this.firstName || "").trim();
      const lName = String(this.lastName || "").trim();
      const mob = String(this.mobile || "").trim();
      const vNum = String(this.vehicleNumber || "").trim();
      const nName = String(this.name || "").trim();

      if (this.isBackOffice) {
        return fName && lName && mob && this.selectedRole && this.birthday;
      }
      if (this.isSalesExecutive) {
        return fName && lName && mob && this.birthday;
      }
      if (this.isDistributorSalesRep) {
        return vNum && mob && this.birthday;
      }
      if (this.isDriverOrHelper) {
        return nName && this.birthday;
      }
      
      return false;
    }
  },

  async created() {
    this.loading = true;
    await this.loadStaffType();
    await this.loadRoleList();

    let idToUse = this.profileId;
    if (this.userCategory === 'DISTRIBUTOR BACK OFFICE') {
      idToUse = this.reportingProfileId;
    }
    await this.loadVehicleList(idToUse);

    await this.loadStaffDetails();
    this.loading = false;
  },

  methods: {
    async loadStaffType() {
      try {
        const response = await fetchStaffType(this.token);
        this.StaffTypeList = response.data.data || [];
        console.log('Fetched StaffList:', this.StaffTypeList);
      } catch (error) {
        console.error('Error fetching StaffList:', error);
      }
    },

    async loadVehicleList(profileId) {
      try {
        const response = await getDistributorVehicles(profileId, this.token);
        this.VehicleList = response.data.data || [];
      } catch (error) {
        console.error('Error fetching vehicle list:', error);
      }
    },

    async loadRoleList() {
      try {
        const response = await fetchDistributorUserRoleListForUserForm(this.token);
        this.UserRoleList = response.data.data || [];
        this.filteredRoles = [...this.UserRoleList]; // Initialize filtered list
      } catch (error) {
        console.error('Error fetching user roles:', error);
      }
    },

    async loadStaffDetails() {
      const type = this.$route.query.type || '';

      try {
        const response = await viewStaffDetailsById(this.staffId, type, this.token);
        const staffData = response.data.data;

        if (staffData) {
          let searchString = '';
          if (type === 'dsr') searchString = 'sales rep';
          else if (type === 'se') searchString = 'sales executive';
          else if (type === 'back-office') searchString = 'back office';
          else if (type === 'driver') searchString = 'driver';
          else if (type === 'helper') searchString = 'helper';

          if (searchString) {
             const found = this.StaffTypeList.find(s => {
               const sType = (s.staff_type || s.staf_type || '').toLowerCase();
               return sType.includes(searchString);
             });
             this.selectedStaffType = found ? found.id : (staffData.staff_type || '');
          } else {
             this.selectedStaffType = staffData.staff_type || '';
          }

          this.name = staffData.name || '';
          this.firstName = staffData.first_name || '';
          this.lastName = staffData.last_name || '';
          this.mobile = staffData.mobile || '';
          this.birthday = staffData.birthday || '';
          this.selectedRole = staffData.role_id || null;
          if (type === 'dsr') {
            this.vehicleNumber = staffData.first_name || staffData.vehicle_no || '';
          } else {
            this.vehicleNumber = staffData.vehicle_id || staffData.vehicle_no || '';
          }
          this.isActive = (staffData.is_active === "1" || staffData.is_active === 1) ? true : false;
        }

        console.log("Fetched staff details:", staffData);
      } catch (error) {
        console.error("Error fetching staff details:", error);
      }
    },

    async updateStaff() {
      if (!this.selectedStaffType) {
        useToast().error("Please select a staff type.");
        return;
      }

      if (this.isDriverOrHelper && !this.name.trim()) {
        useToast().error("Please enter a name.");
        return;
      }

      if (!this.isFormValid) {
        useToast().error("Please fill all required fields.");
        return;
      }

      // Set saving state
      this.isSaving = true;

      if (this.isDriverOrHelper) {
        const payload = {
          staff_type: this.selectedStaffType,
          name: this.name,
          birthday: this.birthday,
          is_active: this.isActive ? "1" : "0",
        };

        try {
          await updateStaffDetails(this.staffId, this.token, payload);
          useToast().success("Staff updated successfully!");
          this.$router.push('/distributor-staff');
        } catch (error) {
          console.error("Error response:", error.response);
          useToast().error("Failed to update staff. Please try again.");
        } finally {
          this.isSaving = false;
        }
      } else {
        let orgStructId = 0;
        let firstNameToUse = this.firstName;
        let lastNameToUse = this.lastName || '';
        let roleIdToUse = this.selectedRole;
        
        let idToUse = this.profileId;
        if (this.userCategory === 'DISTRIBUTOR BACK OFFICE') {
          idToUse = this.reportingProfileId;
        }
        if (this.isBackOffice) {
          orgStructId = 16;
          roleIdToUse = this.selectedRole;
        } else if (this.isSalesExecutive) {
          orgStructId = 17;
          roleIdToUse = 13;
        } else if (this.isDistributorSalesRep) {
          orgStructId = 14;
          firstNameToUse = this.vehicleNumber;
          roleIdToUse = 2;
        }

        const payload = {
          is_active: this.isActive ? "1" : "0",
          dob: this.birthday,
          first_name: firstNameToUse,
          last_name: lastNameToUse,
          mobile: this.mobile,
          company_id: 1,
          org_struct_id: orgStructId,
          role_id: roleIdToUse,
          reporting_to: idToUse,
        };

        try {
          await updateUser(this.staffId, this.token, payload);
          useToast().success("User updated successfully!");
          this.$router.push('/distributor-staff');
        } catch (error) {
          console.error("Error response:", error.response);
          if (error.response && error.response.data && error.response.data.errors) {
            Object.values(error.response.data.errors).forEach((messages) => {
              messages.forEach((message) => useToast().error(message));
            });
          } else {
            useToast().error("Failed to update user. Please try again.");
          }
        } finally {
          this.isSaving = false;
        }
      }
    },

    Cancel() {
      if (!this.isSaving) {
        this.$router.push({ path: "/distributor-staff" });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.custom-card {
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 24px;
  padding: 16px;
}

.staff-type-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
  margin-top: 12px;
}

.staff-type-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  background-color: white;
  text-transform: uppercase;

  &:hover {
    border-color: #007bff;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &.selected {
    border-color: #007bff;
    background-color: #e7f3ff;
  }
}

.disabled-box {
  cursor: not-allowed;
  opacity: 0.6;
}

.disabled-box:hover {
  border-color: #e0e0e0;
  transform: none;
  box-shadow: none;
}

.disabled-box.selected:hover {
  border-color: #007bff;
}

.staff-icon {
  font-size: 24px;
  margin-bottom: 8px;
  color: #6c757d;

  .selected & {
    color: #007bff;
  }
}

.staff-label {
  font-weight: 500;
  text-align: center;
  color: #495057;

  .selected & {
    color: #007bff;
    font-weight: 600;
  }
}

.selected-indicator {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  background-color: #007bff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
}

.name-input {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 12px;
  width: 100%;
  margin-top: 8px;
  font-size: 16px;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }

  &:disabled {
    background-color: #e9ecef;
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.name-input.compact {
  padding: 8px 12px;
  font-size: 14px;
  margin-top: 0;
}

.fields-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 16px;
  margin-bottom: 24px;
}

.field-item {
  display: flex;
  flex-direction: column;
}

.field-item.full-width {
  grid-column: 1 / -1;
}

.field-item label {
  font-size: 14px;
  margin-bottom: 4px;
}

.toggle-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;

  .form-label {
    margin-bottom: 0;
    font-weight: 500;
  }
}

.toggle-wrapper {
  display: flex;
  align-items: center;
}

.toggle-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  &.active .toggle-slider {
    background-color: #28a745;

    &::before {
      transform: translateX(24px);
    }
  }

  &.inactive .toggle-slider {
    background-color: #dc3545;

    &::before {
      transform: translateX(0);
    }
  }
}

.toggle-slider {
  width: 50px;
  height: 26px;
  background-color: #ccc;
  border-radius: 34px;
  position: relative;
  transition: all 0.3s ease;

  &::before {
    content: "";
    position: absolute;
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    border-radius: 50%;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
}

.action-buttons {
  padding: 16px;
  gap: 12px;

  .btn {
    padding: 10px 20px;
    border-radius: 4px;
    font-weight: 500;
    min-width: 100px;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}

.save-button {
  position: relative;
  min-width: 120px;
}

.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* added by isindu | 2025/ 12/ 02 */
.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin: 20px 0;
  color: #007bff;
}


.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .staff-type-container {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  }

  .custom-card {
    padding: 16px;
  }

  .form-group, .fields-container {
    padding: 12px;
  }

  .fields-container {
    grid-template-columns: 1fr;
  }
}
</style>